import { createContext } from 'react';

const defaultContext = {
  isScrollableHeight: false,
  setIsScrollableHeight: () => {},
};

const ModalContext = createContext(defaultContext);

export default ModalContext;
